import * as React from "react";
import styled from "styled-components";

import DetailsPageActionBar from "@client/components/modules/DetailsPage/ActionBar";

import DetailsPageHeader from "../containers/DetailsPageHeader";

import { Action } from "@client/components/ui/DropdownAction";
import Style from "@client/utils/Style";

export type NavigationItems = {
  id: string;
  label: string;
};

const Wrapper = styled.div`
  min-width: 1100px;
`;
const ContentWrapper = styled.div`
  padding: 32px 0;
  display: flex;
  justify-content: center;
`;
const Navigation = styled.div`
  min-width: 176px;
  max-width: 176px;
`;
const NavigationLink = styled.div<{ selected?: boolean }>`
  cursor: pointer;
  color: ${props =>
    props.selected ? Style.palette.primaryHighlight : Style.palette.primary};
  margin-bottom: 8px;
`;
const Content = styled.div`
  width: 928px;
`;
type Props = {
  contentComponent: React.ReactNode;
  backLink: string;
  dropdownActions: Action[];
  icon: any;
  subtitle: React.ReactNode;
  title: string;
  navigationItems?: NavigationItems[];
  selectedNavigationItem?: string;
  onNavigationItemClick?: (id: string) => void;
};
const DetailsTemplate = (props: Props) => {
  return (
    <Wrapper>
      <DetailsPageHeader />
      <DetailsPageActionBar
        backLink={props.backLink}
        dropdownActions={props.dropdownActions}
        icon={props.icon}
        subtitle={props.subtitle}
        title={props.title}
      />
      <ContentWrapper>
        <Navigation>
          {props.navigationItems?.map(item => (
            <NavigationLink
              selected={item.id === props.selectedNavigationItem}
              key={item.id}
              onClick={() => props.onNavigationItemClick?.(item.id)}
            >
              {item.label}
            </NavigationLink>
          ))}
        </Navigation>
        <Content>{props.contentComponent}</Content>
      </ContentWrapper>
    </Wrapper>
  );
};

export default DetailsTemplate;
